import React from "react";
import Popup from "../../../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../../../assets/closeModel.png";
import CustomButton from "../../../../components/common/button/CustomButton";
import useStyles from "../../../../components/common/model/styles";
import { useDispatch } from "react-redux";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";

interface ActivationPopupProps {
  title?: string;
  open: boolean;
  onHide?: () => void;
  alertModalShow: boolean;
  setAlertModelShow: (show: boolean) => void;
  setShowSuccessMessage?: (message: string) => void;
  onConfirm?: () => void;
}
const ManageServicePayment: React.FC<ActivationPopupProps> = ({
  onHide,
  alertModalShow,
  setAlertModelShow,
  onConfirm
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
    const submitHandler = () => {
    if (onConfirm) {
      onConfirm();   // <-- call parent function
    }
    closeModel();    // <-- also close popup after confirming
  };
  const closeModel = () => {
    setAlertModelShow(false);
     dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  return (
    <Popup
      open={alertModalShow}
      title={"Alert"}
      onHide={closeModel}
      fullWidth={true}
      maxWidth={"xs"}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={closeModel}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
          <CustomButton variant="outlined" title="No" onClick={closeModel} />
          <CustomButton title="Yes" onClick={submitHandler} />
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          <Alert
            sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
            severity="warning"
          >
            Are you sure you want to make this a paid service record?
          </Alert>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default ManageServicePayment;
